module.exports = "/lucky-balls/img/regular_game/header_oktagon.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/header_oktagon.png
// module id = 1147
// module chunks = 0